<!--
  @description: 公众号配置组件
  @author: system
  @date: 2026-06-02
  @note: 负责公众号的增删改查和配置管理
-->
<template>
  <div class="account-config-container">
    <!-- 操作栏 -->
    <div class="header-toolbar">
      <div class="toolbar-left">
        <el-input
          v-model="listQuery.account_name"
          placeholder="请输入公众号名称搜索"
          clearable
          @clear="getListData"
          @keyup.enter.native="getListData"
          style="width: 280px;"
          class="search-input"
        ></el-input>
        <el-input
          v-model="listQuery.appid"
          placeholder="请输入APPID搜索"
          clearable
          @clear="getListData"
          @keyup.enter.native="getListData"
          style="width: 280px; margin-left: 10px;"
          class="search-input"
        >
          <el-button slot="append" icon="el-icon-search" @click="getListData"></el-button>
        </el-input>
      </div>
      <div class="toolbar-right">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增公众号</el-button>
      </div>
    </div>

    <!-- 卡片列表 -->
    <div class="cards-container" v-loading="loading">
      <div class="card-item" v-for="item in tableData" :key="item.id">
        <!-- 卡片头部 -->
        <div class="card-header">
          <div class="card-title">
            <div class="title-icon">
              <i class="el-icon-chat-dot-round"></i>
            </div>
            <div class="title-text">
              <h3>{{ item.account_name }}</h3>
              <span class="card-code">APPID: {{ item.appid }}</span>
            </div>
          </div>
          <div class="card-qrcode">
            <el-image
              class="qrcode-img"
              :src="item.gzh_img"
              :preview-src-list="[item.gzh_img]"
              v-if="item.gzh_img"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <div class="no-image" v-else>
              <i class="el-icon-picture-outline"></i>
              <span>暂无二维码</span>
            </div>
          </div>
        </div>

        <!-- 卡片内容 -->
        <div class="card-content">
          <div class="info-item">
            <i class="el-icon-key"></i>
            <span class="info-label">AppSecret：</span>
            <span class="info-value secret-text">{{ item.appsecret }}</span>
          </div>
          <div class="info-item">
            <i class="el-icon-user"></i>
            <span class="info-label">关注数：</span>
            <span class="info-value">{{ item.fans_count || 0 }}</span>
            <el-button
              type="text"
              icon="el-icon-refresh"
              @click="refreshFansCount(item)"
              :loading="item.refreshing"
              class="refresh-btn"
              size="mini"
            >刷新</el-button>
          </div>
          <!-- <div class="info-item">
            <i class="el-icon-check"></i>
            <span class="info-label">登录数：</span>
            <span class="info-value">{{ item.login_count || 0 }}</span>
          </div>
          <div class="info-item">
            <i class="el-icon-document"></i>
            <span class="info-label">消息模版数：</span>
            <span class="info-value">{{ item.template_count || 0 }}</span>
          </div> -->
        </div>

        <!-- 卡片底部操作栏 -->
        <div class="card-footer">
          <div class="footer-left">
            <span class="create-time">
              <i class="el-icon-time"></i>
              {{ item.create_time || '-' }}
            </span>
          </div>
          <div class="footer-right">
            <el-button
              type="text"
              icon="el-icon-copy-document"
              @click="handleCopy(item)"
              class="action-btn"
            >用户登录链接</el-button>
            <el-button
              type="text"
              icon="el-icon-edit"
              @click="handleEdit(item)"
              class="action-btn"
            >编辑</el-button>
            <el-button
              type="text"
              icon="el-icon-delete"
              @click="handleDelete(item)"
              class="action-btn delete-btn"
            >删除</el-button>
          </div>
        </div>

        <!-- 科技感光效 -->
        <div class="card-glow"></div>
      </div>

      <!-- 空状态 -->
      <div v-if="!loading && tableData.length === 0" class="empty-state">
        <i class="el-icon-chat-dot-round"></i>
        <p>暂无公众号信息</p>
        <el-button type="primary" @click="handleAdd">立即添加</el-button>
      </div>
    </div>

    <!-- 分页 -->
    <div class="pagination-container" v-if="tableData.length > 0">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="listQuery.pageNumber"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="listQuery.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="listQuery.total"
        background
      ></el-pagination>
    </div>

    <!-- 新增/编辑抽屉 -->
    <common-drawer
      :visible.sync="dialogFormVisible"
      :title="inputTypeName"
      size="500px"
      @confirm="save"
      @cancel="handleCancel"
    >
      <el-form ref="form" :model="dialogForm" label-width="130px" class="drawer-form">
        <el-form-item label="公众号二维码" required>
          <el-input clearable v-model="dialogForm.gzh_img" placeholder="图片地址"></el-input>
          <el-upload
            name="formData"
            class="upload-demo"
            :action="action"
            :on-success="handleSuccess"
            multiple
            :limit="1"
            :file-list="fileList"
          >
            <el-button
              class="addBtn uploadPic"
              size="mini"
              type="primary"
              style="padding: 9px 5px; margin-top: 10px;"
            >上传图片</el-button>
            <div slot="tip" class="el-upload__tip">请上传jpg，png格式</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="公众号名称" required>
          <el-input v-model="dialogForm.account_name" clearable placeholder="请输入公众号名称"></el-input>
        </el-form-item>
        <el-form-item label="appid" required>
          <el-input v-model="dialogForm.appid" clearable placeholder="请输入appid"></el-input>
        </el-form-item>
        <el-form-item label="appsecret" required>
          <el-input
            v-model="dialogForm.appsecret"
            clearable
            placeholder="请输入appsecret"
            :disabled="!!dialogForm.id"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="用户登录链接">
          <el-input v-model="dialogForm.login_link" clearable placeholder="请输入登录链接，技术人员配置" disabled></el-input>
        </el-form-item> -->
        <el-alert
          title="请将IP：175.24.232.25 添加到公众号白名单"
          type="warning"
          :closable="false"
          style="margin-top: 10px;"
        ></el-alert>
      </el-form>
    </common-drawer>
  </div>
</template>

<script>
/**
 * @description 公众号配置组件
 * @component AccountConfig
 * @requires services/sendService/sendAccount - 公众号相关API
 */
import {
  selectApi,
  updateApi,
  deleteApi,
  addApi,
  getFansNumApi
} from "@/services/sendService/sendAccount";
import CommonDrawer from "@/components/drawer/index.vue";
import { mapState } from "vuex";
import { IP } from "@/services/config";

export default {
  name: "AccountConfig",
  components: {
    CommonDrawer
  },
  created() {
    // 组件创建时获取公众号列表数据
    this.getListData();
  },
  data() {
    return {
      // 上传文件的服务器地址
      action: IP + "/uploadFile/add",
      // 列表加载状态
      loading: false,
      // 列表查询参数
      listQuery: {
        type: 1,
        pageNumber: 1,
        pageSize: 10,
        total: 0,
        account_name: "",
        appid: ""
      },
      // 公众号列表数据
      tableData: [],
      // 抽屉可见性
      dialogFormVisible: false,
      // 操作类型名称（新增/编辑）
      inputTypeName: "",
      // 上传文件列表
      fileList: [],
      // 表单数据
      dialogForm: {}
    };
  },
  computed: {
    ...mapState(["userInfo", "filterStoreList"])
  },
  methods: {
    /**
     * @description 获取公众号列表数据
     */
    async getListData() {
      let listQuery = JSON.parse(JSON.stringify(this.listQuery));
      listQuery.store_id =
        listQuery.store_id?.join(",") || this.userInfo.store_id;
      this.loading = true;
      const { data, code, count } = await selectApi(listQuery);
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 600);
      }
    },

    /**
     * @description 页码改变事件
     * @param {number} pageNumber - 新的页码
     */
    handleCurrentChange(pageNumber) {
      this.listQuery.pageNumber = pageNumber;
      this.getListData();
    },

    /**
     * @description 每页条数改变事件
     * @param {number} pageSize - 新的每页条数
     */
    handleSizeChange(pageSize) {
      this.listQuery.pageSize = pageSize;
      this.getListData();
    },

    /**
     * @description 新增公众号
     */
    handleAdd() {
      this.dialogFormVisible = true;
      this.inputTypeName = "新增公众号";
      this.dialogForm = {};
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },

    /**
     * @description 编辑公众号
     * @param {Object} row - 公众号数据
     */
    handleEdit(row) {
      this.dialogFormVisible = true;
      this.inputTypeName = "编辑公众号";
      this.dialogForm = JSON.parse(JSON.stringify(row));
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },

    /**
     * @description 上传图片成功回调
     * @param {Object} response - 上传响应数据
     */
    handleSuccess(response) {
      this.dialogForm.gzh_img = response.data;
      this.fileList = [];
      this.$message.success("上传成功，请继续操作");
    },

    /**
     * @description 复制公众号登录链接
     * @param {Object} row - 公众号数据
     */
    async handleCopy(row) {
      let link = row.login_link
        ? row.login_link
        : "https://h5.yooolyn.com/#/login";
      link += `?appid=${row.appid}`;
      try {
        // 检查浏览器是否支持Clipboard API
        if (!navigator.clipboard) {
          this.$message.error("复制功能不支持");
          return;
        }
        // 复制链接到剪贴板
        await navigator.clipboard.writeText(link);
        this.$message.success("复制成功");
      } catch (err) {
        this.$message.error("复制失败");
        console.error("复制失败:", err);
      }
    },

    /**
     * @description 保存公众号（新增或编辑）
     */
    save() {
      // 必填字段校验
      if (
        !this.dialogForm.account_name ||
        !this.dialogForm.appid ||
        !this.dialogForm.appsecret ||
        !this.dialogForm.gzh_img
      ) {
        this.$message.error("请填写必填字段");
        return;
      }

      if (this.inputTypeName === "新增公众号") {
        // 新增公众号
        addApi({ ...this.dialogForm }).then(res => {
          if (res.code === 200) {
            this.$message.success("新增成功!");
            this.dialogFormVisible = false;
            this.getListData();
          }
        });
      } else if (this.inputTypeName === "编辑公众号") {
        // 编辑公众号
        updateApi(this.dialogForm).then(res => {
          if (res.code === 200) {
            this.$message.success("修改成功!");
            this.dialogFormVisible = false;
            this.getListData();
          }
        });
      }
    },

    /**
     * @description 取消操作
     */
    handleCancel() {
      this.dialogFormVisible = false;
    },

    /**
     * @description 删除公众号
     * @param {Object} row - 公众号数据
     */
    handleDelete(row) {
      this.$confirm(
        `此操作将永久删除'${row.account_name}'吗, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          deleteApi({ id: row.id }).then(res => {
            if (res.code === 200) {
              this.$message.success("删除成功!");
              this.getListData();
            }
          });
        })
        .catch(() => {});
    },

    /**
     * @description 刷新关注数
     * @param {Object} row - 公众号数据
     */
    async refreshFansCount(row) {
      // 设置刷新状态
      this.$set(row, "refreshing", true);

      try {
        const { data, code, msg } = await getFansNumApi({ appid: row.appid });
        if (code === 200) {
          // 更新关注数
          row.fans_count = data.total;
          this.$message.success("关注数据更新成功!");
        }
      } catch (error) {
        console.error("刷新关注数失败:", error);
      } finally {
        this.$set(row, "refreshing", false);
      }
    }
  }
};
</script>

<style scoped lang="less">
.account-config-container {
  padding: 20px 0;
  min-height: calc(100vh - 150px);

  // 头部工具栏
  .header-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .toolbar-left {
      flex: 1;
    }

    .toolbar-right {
      margin-left: 20px;

      .el-button--primary {
        background-color: #165DFF;
        border-color: #165DFF;

        &:hover,
        &:focus {
          background-color: #4080FF;
          border-color: #4080FF;
        }
      }
    }

    .search-input {
      /deep/ .el-input-group__append {
        background-color: #165DFF;
        border-color: #165DFF;
        color: #fff;
        cursor: pointer;
        transition: all 0.3s;

        &:hover {
          background-color: #4080FF;
        }
      }
    }
  }

  // 卡片容器
  .cards-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
    gap: 24px;
    max-height: 500px;
    min-height: 400px;
    overflow-y: auto;
    align-content: start;
    padding-right: 5px;
    position: relative;

    // 滚动条样式
    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: #165DFF;
      border-radius: 4px;

      &:hover {
        background: #4080FF;
      }
    }

    // 单个卡片
    .card-item {
      position: relative;
      background: #fff;
      border-radius: 12px;
      padding: 24px;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
      transition: all 0.3s ease;
      overflow: hidden;
      border: 1px solid #f0f0f0;

      &:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 24px rgba(102, 126, 234, 0.2);

        .card-glow {
          opacity: 1;
        }
      }

      // 科技感光效
      .card-glow {
        position: absolute;
        top: -50%;
        left: -50%;
        width: 200%;
        height: 200%;
        background: radial-gradient(
          circle,
          rgba(102, 126, 234, 0.1) 0%,
          transparent 70%
        );
        opacity: 0;
        transition: opacity 0.3s ease;
        pointer-events: none;
      }

      // 卡片头部
      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 20px;
        padding-bottom: 16px;
        border-bottom: 2px solid #f0f0f0;

        .card-title {
          display: flex;
          align-items: center;
          gap: 12px;
          flex: 1;

          .title-icon {
            width: 48px;
            height: 48px;
            border-radius: 12px;
            background: #165DFF;
            display: flex;
            align-items: center;
            justify-content: center;

            i {
              font-size: 24px;
              color: #fff;
            }
          }

          .title-text {
            flex: 1;

            h3 {
              margin: 0 0 6px 0;
              font-size: 18px;
              font-weight: 600;
              color: #333;
              line-height: 1.2;
            }

            .card-code {
              font-size: 12px;
              color: #999;
              font-family: "Courier New", monospace;
              background: #f5f5f5;
              padding: 2px 8px;
              border-radius: 4px;
              display: inline-block;
              max-width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }

        .card-qrcode {
          flex-shrink: 0;
          margin-left: 12px;

          .qrcode-img {
            width: 60px;
            height: 60px;
            border-radius: 8px;
            border: 2px solid #f0f0f0;
            overflow: hidden;

            /deep/ .el-image__inner {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }

            .image-slot {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 100%;
              height: 100%;
              background: #f5f5f5;
              color: #ccc;

              i {
                font-size: 24px;
              }
            }
          }

          .no-image {
            width: 60px;
            height: 60px;
            border-radius: 8px;
            border: 2px dashed #ddd;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background: #fafafa;
            color: #ccc;

            i {
              font-size: 20px;
              margin-bottom: 2px;
            }

            span {
              font-size: 10px;
            }
          }
        }
      }

      // 卡片内容
      .card-content {
        margin-bottom: 20px;

        .info-item {
          display: flex;
          align-items: flex-start;
          padding: 10px 0;
          color: #666;
          font-size: 14px;

          i {
            font-size: 16px;
            margin-right: 8px;
            color: #165DFF;
            margin-top: 2px;
          }

          .info-label {
            font-weight: 500;
            margin-right: 8px;
            color: #666;
            flex-shrink: 0;
          }

          .info-value {
            flex: 1;
            color: #333;

            &.secret-text {
              font-family: "Courier New", monospace;
              font-size: 13px;
              word-break: break-all;
              line-height: 1.5;
            }
          }

          .refresh-btn {
            margin-left: 8px;
            padding: 4px 8px;
            font-size: 12px;
            color: #165DFF;

            &:hover {
              color: #4080FF;
            }
          }
        }
      }

      // 卡片底部
      .card-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 16px;
        border-top: 1px solid #f0f0f0;

        .footer-left {
          .create-time {
            font-size: 12px;
            color: #999;
            display: flex;
            align-items: center;
            gap: 4px;

            i {
              font-size: 14px;
            }
          }
        }

        .footer-right {
          display: flex;
          gap: 8px;

          .action-btn {
            padding: 8px 16px;
            font-size: 13px;

            &:hover {
              color: #165DFF;
            }

            &.delete-btn:hover {
              color: #f56c6c;
            }
          }
        }
      }
    }

    // 空状态
    .empty-state {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 80px 20px;
      background: #fff;
      border-radius: 12px;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
      text-align: center;

      i {
        font-size: 80px;
        color: #ddd;
        margin-bottom: 20px;
      }

      p {
        font-size: 16px;
        color: #999;
        margin-bottom: 20px;
      }
    }
  }

  // 分页
  .pagination-container {
    margin-top: 30px;
    padding: 20px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    display: flex;
    justify-content: center;
  }

  // 抽屉表单
  .drawer-form {
    padding: 20px 0;

    .upload-demo {
      margin-top: 10px;

      .el-upload__tip {
        margin-top: 5px;
        color: #999;
        font-size: 12px;
      }
    }
  }
}

// 响应式设计
@media (max-width: 1400px) {
  .account-config-container {
    .cards-container {
      grid-template-columns: repeat(auto-fill, minmax(340px, 1fr)) !important;
    }
  }
}

@media (max-width: 768px) {
  .account-config-container {
    .header-toolbar {
      flex-direction: column;
      gap: 15px;

      .toolbar-left,
      .toolbar-right {
        width: 100%;
        margin: 0;
      }

      .search-input {
        width: 100% !important;
      }
    }

    .cards-container {
      grid-template-columns: 1fr !important;
    }
  }
}
</style>
